<div class="get-care-now-title-container-web">{{title}}</div>
<div class="get-care-now-description-container-web">
    <div>{{description}}</div>
</div>
<div *ngIf="primaryCareProviderOptions != null && primaryCareProviderOptions.length > 0"  class="get-care-now-scroll-container-web">
    <app-primary-care-provider-option-card
      *ngFor="let option of primaryCareProviderOptions"
      [providerId]="option.providerId"
      [departmentId]="option.departmentId"
      [name]="option.providerName"
      [specialties]="option.specialties"
      [city]="option.city"
      [phone]="option.phone"
      [photo]="option.photo"
      [isPcp]="option.isPcp"
      [availability]="option.nextAvailability"
      [distance]="option.distanceInMiles"
      [specialtyId]="option.specialtyId"
      [locale]="locale"
      [pcpId]="pcpId"
      [isOpenScheduling]="option.isOpenScheduling">
    </app-primary-care-provider-option-card>
</div>
<div *ngIf="primaryCareProviderOptions != null && primaryCareProviderOptions.length > 0" style="align-items: center; justify-content: center; display: flex; padding: 24px;">
  <button mat-button class="action-button-secondary" style="border-radius: 12px;" (click)="showMeMore()">{{showMoreText}}</button>
</div>
<div *ngIf="!primaryCareProviderOptions || primaryCareProviderOptions.length === 0" style="width: 190px; height:190px; margin-top: 16px; margin-left: 16px;">
    <ng-container>
        <div class="get-care-now-loading-spinner-mobile">
            <mat-spinner></mat-spinner>
        </div>
    </ng-container>
</div>